module.exports = __webpack_public_path__ + "img/clipboard.408cfdf6.png";